import { Suspense } from "react"

import { CurrentPlanCard, CurrentPlanCardSkeleton } from "./CurrentPlanCard"
import { UsagePageTabContentGrid } from "./UsagePageTabContentGrid"
import { UsageSummary, UsageSummarySkeleton } from "./UsageSummary"

export function ApiAndBandwidthTabContent() {
  return (
    <UsagePageTabContentGrid>
      <Suspense fallback={<UsageSummarySkeleton />}>
        <UsageSummary />
      </Suspense>
      <Suspense fallback={<CurrentPlanCardSkeleton />}>
        <CurrentPlanCard />
      </Suspense>
    </UsagePageTabContentGrid>
  )
}
